var _circle, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExitBtn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 20,
    cy: 20,
    r: 19.085,
    stroke: "#fff",
    strokeWidth: 1.83
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.161 14.839L14.84 25.16M14.839 14.839L25.16 25.16"
  }))));
}

export default SvgExitBtn;